import {Component, OnInit} from '@angular/core';
import {ScheduleDownloadButtonService} from '../schedule-download-button/schedule-download-button.service';
import {CalibrationScheduleService} from '../../services/calibration-schedule.service';
import {EventsService} from '@services/events.service';
import {AjaxDownloadService} from '@components/ajax-download-noty/ajax-download.service';
import {Router} from '@angular/router';
import {RoutesStorage} from '@helpers/routes.helper';

export enum ViewStatus {
    menu,
    form, // возможно понадобится позже, когда добавятся настраиваемые графики (по аналогии с JournalDownloadMenuComponent)
}

@Component({
    selector: 'app-schedule-download-menu',
    templateUrl: './schedule-download-menu.component.html',
    styleUrls: ['./schedule-download-menu.component.scss']
})
export class ScheduleDownloadMenuComponent implements OnInit {

    constructor(
        public service: ScheduleDownloadButtonService,
        public scheduleService: CalibrationScheduleService,
        private ajaxDownloadService: AjaxDownloadService,
        private events: EventsService,
        private router: Router,
    ) {
    }

    public viewStatusesEnum = ViewStatus;
    public viewStatus = ViewStatus.menu;

    public currentYear = (new Date()).getFullYear();

    ngOnInit() {
    }

    /**
     * Установить новое состояние отображения.
     * Поскольку сразу после клика кнопка, по которой кликнули, пропадет из DOM, нужно остановить всплытие события,
     * чтобы Dropdown не закрылся
     * @param event
     * @param status
     */
    setViewStatus(event: Event, status: ViewStatus) {
        event.preventDefault();
        event.stopPropagation();
        this.viewStatus = status;
    }

    generateCurrentYear() {
        if (this.service.allDownloadQueue$ && this.service.allDownloadQueue$.getValue().fetching) {
            return;
        }

        this.scheduleService.post({
            url: this.scheduleService.validateUrl
        }).subscribe(() => {
            this.service.allDownloadQueue$ = this.ajaxDownloadService.do({
                url: this.scheduleService.generateUrl,
                method: 'post',
                currentQueue: this.service.allDownloadQueue$,
                taskName: 'График поверки',
            });
        }, (errors) => {
            let message = 'Не удалось сформировать график поверки';

            if (errors && errors instanceof Array && errors.length) {
                message = errors.join('<br>');
            }

            this.events.showNoty({
                type: 'error',
                content: message,
                controls: [
                    {
                        title: 'Перейти в настройки',
                        callback: () => this.router.navigateByUrl(RoutesStorage.Organization.edit)
                    }
                ]
            });
        });
    }
}
